import {
  LOAD_EDITOR_UI_BOOK_PROPERTIES,
  CHANGE_BOOK_BACKGROUND_IMAGE,
  CHANGE_BOOK_BACKGROUND_TYPE,
  LOAD_BOOK_BACKGROUND_TYPE } from '../../action-types/ui/bookProperties';

export const STATE_KEY = 'bookProperties';

const stateObject = {
  backgroundImage: '',
  backgroundImageFull: '',
  backgroundType: '',
  backgroundSize: {},
};

export const bookProperties = (state = stateObject, action) => {
  switch (action.type) {
    case LOAD_EDITOR_UI_BOOK_PROPERTIES: {
      return action.context;
    }
    case CHANGE_BOOK_BACKGROUND_IMAGE: {
      const { image, fullImage, size } = action;
      return Object.assign({}, state, {
        backgroundImage: image,
        backgroundImageFull: fullImage,
        backgroundSize: size,
      });
    }

    case CHANGE_BOOK_BACKGROUND_TYPE: {
      const { backgroundType } = action;
      return Object.assign({}, state, {
        backgroundType,
      });
    }

    case LOAD_BOOK_BACKGROUND_TYPE: {
      return action.bookProperties;
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/ui/bookProperties.js